import FilesLightboxDialog from './FilesLightboxDialog'

export * from './FilesLightboxDialog'
export default FilesLightboxDialog
